export default "__VITE_ASSET__C2_QbG00__"